/** Minimal compatibility implementation for masks stored by the AngularJS version. */
import { toEnglishNumbers } from './numbers';

function isDigit(value: string): boolean { return /[0-9]/.test(value); }
function isLetter(value: string): boolean { return /[A-Za-z\u0600-\u06FF]/.test(value); }
function isAlphaNumeric(value: string): boolean { return isDigit(value) || isLetter(value); }

/**
 * Applies the legacy angular-ui/ui-mask conventions used by DynamicForms:
 * 9 = digit, A = letter, * = letter or digit, ? = the next mask token is optional.
 */
export function applyLegacyMask(rawValue: string, mask?: string): string {
  if (!mask) return rawValue;
  const input = toEnglishNumbers(rawValue);
  let inputIndex = 0;
  let output = '';
  let optionalNext = false;

  for (let maskIndex = 0; maskIndex < mask.length; maskIndex++) {
    const token = mask[maskIndex]!;
    if (token === '?') { optionalNext = true; continue; }

    const matcher = token === '9' ? isDigit : token === 'A' ? isLetter : token === '*' ? isAlphaNumeric : undefined;
    if (!matcher) {
      if (inputIndex < input.length || output.length > 0) output += token;
      if (input[inputIndex] === token) inputIndex++;
      optionalNext = false;
      continue;
    }

    let accepted = '';
    while (inputIndex < input.length) {
      const candidate = input[inputIndex++]!;
      if (matcher(candidate)) { accepted = candidate; break; }
    }
    if (accepted) output += accepted;
    else if (!optionalNext) break;
    optionalNext = false;
  }

  return output;
}

export function isLegacyMaskComplete(value: string, mask?: string): boolean {
  if (!mask) return true;
  const normalized = applyLegacyMask(value, mask);
  let valueIndex = 0;
  let optionalNext = false;
  for (let maskIndex = 0; maskIndex < mask.length; maskIndex++) {
    const token = mask[maskIndex]!;
    if (token === '?') { optionalNext = true; continue; }
    const matcher = token === '9' ? isDigit : token === 'A' ? isLetter : token === '*' ? isAlphaNumeric : undefined;
    if (!matcher) {
      if (normalized[valueIndex] === token) valueIndex++;
      optionalNext = false;
      continue;
    }
    const candidate = normalized[valueIndex];
    if (!candidate || !matcher(candidate)) {
      if (!optionalNext) return false;
    } else valueIndex++;
    optionalNext = false;
  }
  return true;
}
